<template>
  <div class="biography-container">
    <img class="biography-icon" src="../../assets/images/arabesque-arabic-flower-1011548.svg" />
    <div class="biography-content" v-html="line.html"></div>
  </div>
</template>

<script>
  export default {
    props: ['line'],
  };
</script>

<style lang="scss" scoped>
  @import "../../variables.scss";

  .biography-container {
    .biography-icon {
      fill: $brand;
      height: 1.25em;
      margin-top: 0.125em;
      margin-left: 0.25em;
      float: right;
    }
    ::v-deep .biography {
        margin-top: 1.0em;
        margin-bottom: 1.0em;
        font-weight: $headings-font-weight;
        color: $brand;
    }
  }
</style>
